"use strict";
/**
 * TS-Promise - fast, robust, type-safe promises
 *
 * Copyright (C) 2015 Martin Poelstra
 * License: MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Promise_1 = require("./Promise");
exports.default = Promise_1.default;
exports.Promise = Promise_1.Promise;
var Trace_1 = require("./Trace");
exports.Trace = Trace_1.default;
var rejections_1 = require("./rejections");
exports.UnhandledRejection = rejections_1.UnhandledRejection;
exports.PossiblyUnhandledRejection = rejections_1.PossiblyUnhandledRejection;
var rejections_2 = require("./rejections"); // backwards compatibility
exports.UnhandledRejectionError = rejections_2.UnhandledRejection;
var polyfill_1 = require("./polyfill");
exports.polyfill = polyfill_1.default;
// Temporary, should be moved to its own package some day
var BaseError_1 = require("./BaseError");
exports.BaseError = BaseError_1.default;
//# sourceMappingURL=index.js.map